<template lang="pug">
  .right
    h2 {{title}}
    slot
    p.explain(v-html = 'explain' )
    .img_wrap
      a.p.img1(:href='downloadUrl' target="_blank")
</template>

<script>
export default {
  props: {
    title: String.isRequired,
    explain: String.isRequired,
    downloadUrl: String.isRequired,
  },
}
</script>

<style lang="stylus">

</style>
